import style from './style.module.css'

// Components
import Chat from '../chat/Chat'
import Companies from './components/Companies'
import Filter from './components/Filter'
import { useEffect, useState } from 'react'
import CompanyModal from './components/CompanyModal'
import axios from 'axios'
import Cookies from 'js-cookie'
import useWindowWidth from '../../../hooks/useWindowWidth'
import Statistic from './components/Statistic'
import FilterHeader from './components/FilterHeader'
import ChatInput from '../chat/ChatInput'

const API_URL = process.env.REACT_APP_API_URL
const token = Cookies.get('token')

const Spotlight = () => {
  const [isCompanyModalOpen, setIsCompanyModalOpen] = useState(false)
  const [modalData, setModalData] = useState(null)
  const [companies, setCompanies] = useState([])
  const [isFilterOpen, setIsFilterOpen] = useState(false)

  const [mobileFilterButtonChoice, setMobileFilterButtonChoice] =
    useState('all')

  const isMobile = useWindowWidth() <= 768

  const handleCompanyOpen = (data) => {
    setModalData(data)
    setIsCompanyModalOpen((prev) => !prev)
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get(`${API_URL}/enterprise`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })

        setCompanies(data)
      } catch (error) {
        console.error(error)
      }
    }

    fetchData()
  }, [])

  return (
    <div className="mainDashboard">
      <div className={style.container}>
        {/* For Mobile View */}
        {isMobile && <Statistic />}
        {isMobile && (
          <FilterHeader
            setIsFilterOpen={setIsFilterOpen}
            mobileFilterButtonChoice={mobileFilterButtonChoice}
            setMobileFilterButtonChoice={setMobileFilterButtonChoice}
          />
        )}

        {/* For Computer View */}
        <Filter isFilterOpen={isFilterOpen} setIsFilterOpen={setIsFilterOpen} />
        <Companies
          companies={companies}
          handleCompanyOpen={handleCompanyOpen}
        />
        <Chat styles={{ minWidth: '340px' }} />

        {isMobile && <ChatInput />}

        {/* Company Modal */}
        {isCompanyModalOpen && (
          <CompanyModal
            data={modalData}
            handleCompanyOpen={handleCompanyOpen}
          />
        )}
      </div>
    </div>
  )
}

export default Spotlight
